import { render, staticRenderFns } from "./PublicationPreview.vue?vue&type=template&id=59f6117e&scoped=true&"
import script from "./PublicationPreview.vue?vue&type=script&lang=js&"
export * from "./PublicationPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f6117e",
  null
  
)

export default component.exports